import { openExternalUrl } from '@/src/utils/external-url'

export async function openPurchaseUrl(url: string) {
  try {
    await openExternalUrl(url)
  } catch (error) {
    console.error('An error occurred', error)
  }
}
